<script lang="ts">
  import type {Notification, User} from '../types'
  import {replaceValues, t} from '../i18n'
  import {Link} from 'svelte5-router'
  import {formatDateTimeRelative} from '../utils/format'

  export let notificationParams: {
    poem_handle: string
    poem_title: string
    sender: User
  }
  export let notification: Notification

  $: sender = notificationParams.sender
</script>

<div class="item">
  <Link class="notice-img" to={sender.link}>
    <img src={sender.avatar_big_thumgb} alt={sender.full_name}/>
  </Link>

  <Link class="notice-content" to={`/poems/${notificationParams.poem_handle}`}>
    <span class="notice-action db">
      {@html replaceValues(t.timelines.received_like, {
        user: sender.full_name,
        user_id: sender.handle,
        poem: notificationParams.poem_title,
        poem_id: notificationParams.poem_handle,
      })}
    </span>
    <i class="notice-time db">{formatDateTimeRelative(notification.created_at)}</i>
  </Link>
</div>
